export default __webpack_public_path__ + "static/media/photo11.f386c0ac.jpg";